export default {
  // Main Page
  'pages.hall-rental.title': 'Hall Rental Management',
  'pages.hall-rental.subTitle': 'Manage community hall reservation information',
  'pages.hall-rental.breadcrumb.serviceManagement': 'Service Management',
  'pages.hall-rental.breadcrumb.hallRental': 'Hall Rental',

  // Table Related
  'pages.hall-rental.table.columns.index': 'Index',
  'pages.hall-rental.table.columns.hallImage': 'Hall Image',
  'pages.hall-rental.table.columns.hallName': 'Hall Name',
  'pages.hall-rental.table.columns.applicantName': 'Applicant Name',
  'pages.hall-rental.table.columns.applicantPhone': 'Contact Phone',
  'pages.hall-rental.table.columns.reservationStart': 'Reservation Start Time',
  'pages.hall-rental.table.columns.reservationEnd': 'Reservation End Time',
  'pages.hall-rental.table.columns.status': 'Status',
  'pages.hall-rental.table.columns.remarks': 'Remarks',
  'pages.hall-rental.table.columns.createdTime': 'Created Time',
  'pages.hall-rental.table.columns.operations': 'Operations',

  // Operation Buttons
  'pages.hall-rental.table.addReservation': 'Add Reservation',
  'pages.hall-rental.table.batchDelete': 'Batch Delete',
  'pages.hall-rental.table.approve': 'Approve',
  'pages.hall-rental.table.view': 'View',
  'pages.hall-rental.table.edit': 'Edit',
  'pages.hall-rental.table.delete': 'Delete',

  // Status Related
  'pages.hall-rental.status.booked': 'Booked',
  'pages.hall-rental.status.approved': 'Approved',
  'pages.hall-rental.status.rejected': 'Rejected',
  'pages.hall-rental.status.cancelled': 'Cancelled',
  'pages.hall-rental.status.completed': 'Completed',
  'pages.hall-rental.status.pending': 'Pending',

  // Message Tips
  'pages.hall-rental.message.createSuccess': 'Created successfully',
  'pages.hall-rental.message.createFailed': 'Creation failed',
  'pages.hall-rental.message.updateSuccess': 'Updated successfully',
  'pages.hall-rental.message.updateFailed': 'Update failed',
  'pages.hall-rental.message.deleteSuccess': 'Deleted successfully',
  'pages.hall-rental.message.deleteFailed': 'Deletion failed',
  'pages.hall-rental.message.batchDeleteSuccess': 'Batch deletion successful',
  'pages.hall-rental.message.batchDeleteFailed': 'Batch deletion failed',
  'pages.hall-rental.message.approveSuccess': 'Approved',
  'pages.hall-rental.message.rejectSuccess': 'Rejected',
  'pages.hall-rental.message.approveFailed': 'Approval failed',
  'pages.hall-rental.message.selectRecordsToDelete': 'Please select records to delete',
  'pages.hall-rental.message.batchDeleteConfirm': 'Are you sure you want to delete the selected {count} records?',
  'pages.hall-rental.message.getDataFailed': 'Failed to get data',
  'pages.hall-rental.message.selectHall': 'Please select a hall',
  'pages.hall-rental.message.invalidTimeRange': 'Reservation end time must be later than start time',

  // Modal Titles
  'pages.hall-rental.modal.detailTitle': 'Reservation Details',
  'pages.hall-rental.modal.approvalTitle': 'Approve Reservation',
  'pages.hall-rental.modal.createTitle': 'Create Hall Reservation',
  'pages.hall-rental.modal.editTitle': 'Edit Hall Reservation',

  // Detail Information
  'pages.hall-rental.detail.hallInfo': 'Hall Information',
  'pages.hall-rental.detail.hallName': 'Hall Name',
  'pages.hall-rental.detail.hallId': 'Hall ID',
  'pages.hall-rental.detail.applicantInfo': 'Applicant Information',
  'pages.hall-rental.detail.applicantName': 'Applicant Name',
  'pages.hall-rental.detail.applicantPhone': 'Contact Phone',
  'pages.hall-rental.detail.ownerId': 'Owner ID',
  'pages.hall-rental.detail.reservationInfo': 'Reservation Information',
  'pages.hall-rental.detail.reservationStart': 'Reservation Start Time',
  'pages.hall-rental.detail.reservationEnd': 'Reservation End Time',
  'pages.hall-rental.detail.status': 'Reservation Status',
  'pages.hall-rental.detail.remarksInfo': 'Remarks Information',
  'pages.hall-rental.detail.remarks': 'Remarks',
  'pages.hall-rental.detail.noRemarks': 'No remarks information',
  'pages.hall-rental.detail.systemInfo': 'System Information',
  'pages.hall-rental.detail.createdTime': 'Created Time',
  'pages.hall-rental.detail.createdBy': 'Created By',
  'pages.hall-rental.detail.updatedTime': 'Updated Time',
  'pages.hall-rental.detail.updatedBy': 'Updated By',

  // Approval Related
  'pages.hall-rental.approval.remarks': 'Approval Comments',
  'pages.hall-rental.approval.remarksPlaceholder': 'Please enter approval comments (optional)',
  'pages.hall-rental.approval.cancel': 'Cancel',
  'pages.hall-rental.approval.reject': 'Reject',
  'pages.hall-rental.approval.approve': 'Approve',
  'pages.hall-rental.approval.confirmReject': 'Confirm Rejection',
  'pages.hall-rental.approval.confirmApprove': 'Confirm Approval',
  'pages.hall-rental.approval.rejectDescription': 'Are you sure you want to reject this hall reservation?',
  'pages.hall-rental.approval.approveDescription': 'Are you sure you want to approve this hall reservation?',

  // Form Related
  'pages.hall-rental.form.hallInfo': 'Hall Information',
  'pages.hall-rental.form.hallName': 'Hall Name',
  'pages.hall-rental.form.selectHall': 'Please select a hall',
  'pages.hall-rental.form.applicantInfo': 'Applicant Information',
  'pages.hall-rental.form.applicantName': 'Applicant Name',
  'pages.hall-rental.form.applicantNamePlaceholder': 'Please enter applicant name',
  'pages.hall-rental.form.applicantPhone': 'Contact Phone',
  'pages.hall-rental.form.applicantPhonePlaceholder': 'Please enter contact phone',
  'pages.hall-rental.form.search': 'Search',
  'pages.hall-rental.form.clear': 'Clear',
  'pages.hall-rental.form.reservationTime': 'Reservation Time',
  'pages.hall-rental.form.reservationStart': 'Reservation Start Time',
  'pages.hall-rental.form.reservationStartPlaceholder': 'Please select reservation start time',
  'pages.hall-rental.form.reservationEnd': 'Reservation End Time',
  'pages.hall-rental.form.reservationEndPlaceholder': 'Please select reservation end time',
  'pages.hall-rental.form.status': 'Reservation Status',
  'pages.hall-rental.form.statusPlaceholder': 'Please select reservation status',
  'pages.hall-rental.form.statusTooltip': 'New reservations default to pending approval',
  'pages.hall-rental.form.remarksInfo': 'Remarks Information',
  'pages.hall-rental.form.remarks': 'Remarks',
  'pages.hall-rental.form.remarksPlaceholder': 'Please enter remarks information (optional)',
  'pages.hall-rental.form.submit': 'Create',
  'pages.hall-rental.form.update': 'Update',
  'pages.hall-rental.form.cancel': 'Cancel',

  // Form Validation
  'pages.hall-rental.form.validation.applicantNameRequired': 'Please enter applicant name',
  'pages.hall-rental.form.validation.applicantNameMaxLength': 'Applicant name cannot exceed 50 characters',
  'pages.hall-rental.form.validation.applicantPhoneRequired': 'Please enter contact phone',
  'pages.hall-rental.form.validation.reservationStartRequired': 'Please select reservation start time',
  'pages.hall-rental.form.validation.reservationEndRequired': 'Please select reservation end time',
  'pages.hall-rental.form.validation.statusRequired': 'Please select reservation status',

  // Owner Selection
  'pages.hall-rental.owner.selectTitle': 'Select Owner',
  'pages.hall-rental.owner.confirm': 'Confirm Selection',
  'pages.hall-rental.owner.cancel': 'Cancel',
  'pages.hall-rental.owner.select': 'Select',
  'pages.hall-rental.owner.username': 'Username',
  'pages.hall-rental.owner.name': 'Name',
  'pages.hall-rental.owner.phone': 'Phone',
  'pages.hall-rental.owner.email': 'Email',
  'pages.hall-rental.owner.idCard': 'ID Card',
  'pages.hall-rental.owner.role': 'Role',
  'pages.hall-rental.owner.status': 'Status',

  // Role Status Mapping
  'pages.hall-rental.role.owner': 'Owner',
  'pages.hall-rental.role.tenant': 'Tenant',
  'pages.hall-rental.role.visitor': 'Visitor',
  'pages.hall-rental.status.normal': 'Normal',
  'pages.hall-rental.status.disabled': 'Disabled',

  // Common
  'pages.hall-rental.common.noImage': 'No image available',
  'pages.hall-rental.common.confirm': 'Confirm',
  'pages.hall-rental.common.cancel': 'Cancel',
};
